import { Modal, Input, Typography, Space } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";

import { useCustomToolStore } from "../../../store/custom-tool-store";
import SpaceWrapper from "../../../components/widgets/space-wrapper/SpaceWrapper";
import { PromptShareLinkFooter } from "../public-share-link-footer/PublicShareLinkFooter.jsx";

function PromptShareLink({ open, setOpenShareLink, setOpenShareModal }) {
  const { shareId } = useCustomToolStore();
  const [shareURL, setShareURL] = useState(
    `${window.location.origin}/promptStudio/share/${shareId}`
  );
  useEffect(() => {
    setShareURL(`${window.location.origin}/promptStudio/share/${shareId}`);
  }, [shareId]);

  const handleClose = () => {
    setOpenShareLink(false);
    setOpenShareModal(false);
  };

  return (
    <SpaceWrapper>
      <Modal
        open={open}
        title={
          <div className="prompt-share-title">
            <ExclamationCircleFilled
              className="prompt-share-icons"
              style={{ fontSize: "16px", color: "#FAAD14" }}
            />
            <Typography.Text className="prompt-share-typography-title">
              This project is shared publicly in read-only mode.
            </Typography.Text>
          </div>
        }
        onCancel={handleClose}
        centered={true}
        closable={true}
        maskClosable={true}
        keyboard={true}
        footer={
          <PromptShareLinkFooter
            setOpenShareLink={setOpenShareLink}
            setOpenShareModal={setOpenShareModal}
          />
        }
      >
        <div className="prompt-share-info">
          <Space direction="vertical" size="middle">
            <Typography.Text className="prompt-share-typography-info">
              Prompt Studio Projects that are shared publicly will be viewable
              by anyone who has the generated unique link.
            </Typography.Text>
          </Space>
          <Input size="default" value={shareURL} />
        </div>
      </Modal>
    </SpaceWrapper>
  );
}

PromptShareLink.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpenShareLink: PropTypes.func.isRequired,
  setOpenShareModal: PropTypes.func.isRequired,
};

export { PromptShareLink };
